// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__LZtsz","navSection":"Nav_navSection__HilH9","navOption":"Nav_navOption__v5B4C","photo":"Nav_photo__3IWTt","selected":"Nav_selected__irQzz"};